/* @flow */

import React from 'react';
import t from 'app/utils/translate';
import classNames from 'classnames';

import TeamSelectButton from '../commons/TeamSelectButton';
import Fieldset from '../commons/Fieldset';
import ResetButton from '../commons/ResetButton';
import useSheet from '../../jss';

type Props = {
  classes: Object,
  filteredTeams: Array<string>,
  selectedTeams?: Array<string>,
  games: Array<*>,
  hasTeams: boolean,
  onReset: () => void,
  onTeamsChange: () => void
};

const defaultProps = {
  selectedTeams: null
};

function OpenChallengeFilterContent({
  classes,
  filteredTeams,
  selectedTeams,
  games,
  hasTeams,
  onTeamsChange,
  onReset
}: Props) {
  return (
    <div className={classes.content}>
      <div className={classes.contentInner}>
        <div className={classes.set}>
          <div className={classNames(classes.row, classes.row1)}>
            {hasTeams ? (
              <Fieldset itemClassName={classes.gameButton} legend={t('Games')}>
                {games.map(game => (
                  <TeamSelectButton
                    key={game.name}
                    awayTeamName={game.awayAbbr}
                    awayTeamId={game.awayId}
                    awayTeamSelected={filteredTeams.includes(game.awayId)}
                    awayImage={game.awayImage}
                    countryCode={game.countryCode}
                    homeImage={game.homeImage}
                    homeTeamName={game.homeAbbr}
                    homeTeamId={game.homeId}
                    homeTeamSelected={filteredTeams.includes(game.homeId)}
                    awayDisabled={
                      Array.isArray(selectedTeams) && selectedTeams.includes(game.awayId) === false
                    }
                    homeDisabled={
                      Array.isArray(selectedTeams) && selectedTeams.includes(game.homeId) === false
                    }
                    onSelect={onTeamsChange}
                  />
                ))}
              </Fieldset>
            ) : (
              <p>Nothing to filter</p>
            )}
          </div>
          <div className={classNames(classes.row, classes.row2)}>
            <ResetButton
              className={classes.reset}
              label={t('Reset Filters')}
              onClick={onReset}
              scheme="dark"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function applyStyles(theme) {
  return {
    content: {
      alignItems: 'flex-start',
      display: 'flex',
      paddingTop: 7,
      paddingBottom: 10
    },
    contentInner: {
      flexGrow: 1
    },
    labelButton: {
      flexBasis: 40
    },
    row: {
      display: 'flex',
      flexWrap: 'wrap',
      paddingLeft: 10,
      paddingRight: 10
    },
    row1: {
      flexGrow: 1
    },
    row2: {
      justifyContent: 'flex-end'
    },
    gameButton: {
      whiteSpace: 'nowrap',
      flexBasis: '33%',
      flexGrow: 0,
      flexShrink: 0
    },
    final: {
      display: 'flex',
      alignSelf: 'flex-end'
    },
    reset: {
      marginLeft: 'auto'
    },
    set: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    [theme.mediaQuery.tabletLandscapeAndUp]: {
      content: {
        fontSize: '0.75rem'
      },
      gameButton: {
        flexBasis: '25%'
      }
    },
    [theme.mediaQuery.desktopAndUp]: {
      content: {
        paddingLeft: 5,
        paddingRight: 5
      },
      gameButton: {
        flexBasis: '20%'
      }
    }
  };
}

OpenChallengeFilterContent.defaultProps = defaultProps;

export default useSheet(applyStyles)(OpenChallengeFilterContent);
